var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.1895C6.65 23.1895 3.5 26.3395 3.5 30.1895C3.5 34.0395 6.65 37.1895 10.5 37.1895C14.35 37.1895 17.5 34.0395 17.5 30.1895C17.5 26.3395 14.35 23.1895 10.5 23.1895ZM21 5.68945C17.15 5.68945 14 8.83945 14 12.6895C14 16.5395 17.15 19.6895 21 19.6895C24.85 19.6895 28 16.5395 28 12.6895C28 8.83945 24.85 5.68945 21 5.68945ZM31.5 23.1895C27.65 23.1895 24.5 26.3395 24.5 30.1895C24.5 34.0395 27.65 37.1895 31.5 37.1895C35.35 37.1895 38.5 34.0395 38.5 30.1895C38.5 26.3395 35.35 23.1895 31.5 23.1895Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialManagement);
export default __webpack_public_path__ + "static/media/material_management.cd29d2247e1d01c46d8170be0688b44c.svg";
export { ForwardRef as ReactComponent };